import { EMPTY_NUMBER_ID } from '@/constant/common'

import { DTO } from '../DTO'

export class Faq extends DTO implements res.Faq {
  id = EMPTY_NUMBER_ID
  type: res.Faq['type'] = 'ETC'
  content = ''
  question = ''
  priority = EMPTY_NUMBER_ID

  constructor(data?: res.Faq) {
    super()
    if (data) this.update<Faq>(data)
  }
}
